export var RabbitMqQueue;
(function (RabbitMqQueue) {
    RabbitMqQueue["THERAME_EVENTS"] = "therame_events";
    RabbitMqQueue["ANALYTICS_EVENTS"] = "analytics_events";
    RabbitMqQueue["ANALYTICS_ERROR"] = "analytics_error";
    RabbitMqQueue["WEBHOOKS_EVENTS"] = "webhooks_events";
    RabbitMqQueue["WEBHOOKS_ERROR"] = "webhooks_error";
    RabbitMqQueue["HUBSPOT_SYNC"] = "hubspot_sync";
    RabbitMqQueue["HUBSPOT_SYNC_DELAY"] = "hubspot_sync_delay";
    RabbitMqQueue["HUBSPOT_SYNC_ERROR"] = "hubspot_sync_error";
    RabbitMqQueue["STRIPE_WEBHOOK"] = "stripe_webhook";
    RabbitMqQueue["STRIPE_ERROR"] = "stripe_error";
    RabbitMqQueue["STRIPE_TEST"] = "stripe_test";
    RabbitMqQueue["KEYCLOAK"] = "forkeycloak";
    RabbitMqQueue["BACKEND"] = "forbackend";
    RabbitMqQueue["HUBSPOT_TO_BACKEND"] = "hubspot_forbackend";
    RabbitMqQueue["KEYCLOAK_TEST"] = "forkeycloak-test";
    RabbitMqQueue["EMAIL"] = "foremail";
    RabbitMqQueue["EMAIL_TEST_TO_BACKEND"] = "test-email-to-backend";
    RabbitMqQueue["EMAIL_ERROR"] = "error-from-email";
})(RabbitMqQueue || (RabbitMqQueue = {}));
export const STRIPE_WEBHOOK_EXCHANGE = 'stripe_webhook_exchange';
export const KEYCLOAK_EVENTS_EXCHANGE = 'keycloak_events_exchange';
export const BACKEND_TO_KEYCLOAK_EXCHANGE = 'backend_to_keycloak_exchange';
export const EMAIL_EXCHANGE = 'email_exchange';
/**
 * Per-worker queue name for observing backend→Keycloak commands in e2e tests.
 *
 * Under `fileParallelism` every vitest worker boots its own backend app against
 * the SAME broker. A fanout copy of every command would land in every worker's
 * queue, flooding the single-message poller so it can never reach its own target
 * command within the timeout (the flaky `BACKEND_CREATE_TAN` w25 failure). So the
 * backend delivers the observability copy straight to THIS worker's queue via the
 * default exchange, and the test asserts on the same deterministic name. Both the
 * backend `KeycloakRpcTransport` and the test `AppSingleton` run in the same
 * vitest worker thread, so they read the same `VITEST_WORKER_ID`.
 */
export function keycloakCommandTestQueueName() {
    const workerId = process.env.VITEST_WORKER_ID ?? process.env.VITEST_POOL_ID ?? 'single';
    return `${RabbitMqQueue.KEYCLOAK_TEST}-w${workerId}`;
}
export var RabbitMqPattern;
(function (RabbitMqPattern) {
    RabbitMqPattern["STRIPE_EVENT"] = "stripe-event";
    RabbitMqPattern["STRIPE_ERROR_EVENT"] = "stripe-error-event";
    RabbitMqPattern["HUBSPOT_EVENT"] = "hubspot-event";
})(RabbitMqPattern || (RabbitMqPattern = {}));
export var StripeWebhookEventPattern;
(function (StripeWebhookEventPattern) {
})(StripeWebhookEventPattern || (StripeWebhookEventPattern = {}));
//# sourceMappingURL=rabbitmq-config.js.map